import React, { useState, useEffect } from "react";
import LoaderSpinner from "../../component/LoaderSpinner";
import HelmetMetaData from "../HelmetMetaData/HelmetMetaData";
import ReactHtmlParser from "react-html-parser";
import SectionTitle from "../../component/SectionTitle";

export default function Index() {
  const [aboutUs, setAboutUs] = useState([]);
  const [steps, setSteps] = useState([]);
  const [content, setContent] = useState([]);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    window.scrollTo(0, 0);
    axios.get("/api/home/about_us", { signal: controller.signal }).then((res) => {
      if (!isMounted) return; //Guard skip state if unmounted
      if (res.data.status == "success") {
        // console.log(res.data.data);
        setLoader(false);
        setAboutUs(res.data.data);
        setSteps(res.data.steps);
        setContent(res.data.content);
      } else {
        setAboutUs([]);
        setSteps([]);
        setContent([]);
      }
    }).catch(error => {
      if (!isMounted) return;
      if (error.name !== "AbortError"  && error.name !== "CanceledError") {
        console.error("Failed to load about us:", error);
      }
    });

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);
  return (
    <React.Fragment>
      <HelmetMetaData />
      <div
        className="section-full p-t120 p-b120 twm-explore-area bg-cover "
        style={{
          backgroundImage: "url(../portal/images/bg-1.jpg)",
        }}
      >
        <div className="container">
          <div className="section-content">
            <div className="row">
              <div className="col-lg-4 col-md-12">
                <div className="twm-explore-media-wrap">
                  <div className="twm-media">
                    <img src={aboutUs.imgUrl1} alt="About Image" />
                  </div>
                </div>
              </div>

              <div className="col-lg-8 col-md-12">
                <div className="twm-explore-content-outer">
                  <div className="twm-explore-content">
                    <div className="twm-l-line-1"></div>
                    <div className="twm-l-line-2"></div>
                    <div className="twm-r-circle-1"></div>
                    <div className="twm-r-circle-2"></div>
                    <div className="twm-title-small">About</div>
                    <div className="twm-title-large">
                      <h2>{aboutUs.page_title}</h2>
                      {ReactHtmlParser(aboutUs.description)}
                    </div>
                  </div>
                  <div className="twm-bold-circle-right"></div>
                  <div className="twm-bold-circle-left"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section-full p-t60 p-b30 site-bg-light twm-how-it-work-area2">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-12">
              <div className="section-head left wt-small-separator-outer">
                <div className="wt-small-separator site-text-primary">
                  <div>How It Works </div>
                </div>
                <h2 className="wt-title">{steps.page_title}</h2>
              </div>
              {ReactHtmlParser(steps.description)}
            </div>
            <div className="col-lg-8 col-md-12">
              <div className="twm-w-process-steps-2-wrap">
                <div className="row">
                  {content.length > 0
                    ? content.map((item, idx) => {
                        let colorName = ["sky", "yellow", "pink", "green"];
                        let titleWords = item.title.split(" ");
                        let firstWord = titleWords[0];
                        let remWords = titleWords.slice(1).join(" ");
                        return (
                          <div className="col-xl-6 col-lg-6 col-md-6">
                            <div className="twm-w-process-steps-2">
                              <div
                                className={`twm-w-pro-top bg-clr-${colorName[idx]}-light bg-${colorName[idx]}-light-shadow`}
                              >
                                <span
                                  className={`twm-large-number text-clr-${colorName[idx]}`}
                                >
                                  0{idx + 1}
                                </span>
                                <div className="twm-media">
                                  <span>
                                    <img src={item.imgUrl3} alt={item.title} />
                                  </span>
                                </div>
                                <h4 className="twm-title">
                                  {firstWord}
                                  <br />
                                  {remWords}
                                </h4>
                                <p>{item.content}</p>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    : ""}
                </div>
              </div>
            </div>
          </div>

          <div className="twm-how-it-work-section"></div>
        </div>
      </div>
    </React.Fragment>
  );
}
